export default class FiltroConsultarLog {
    constructor () {
        this.UsuarioId = undefined;
        this.DescricaoProcesso = undefined;
        this.DataLog = undefined;
        this.Acesso = undefined;
        this.Consulta = undefined;
        this.Fim = undefined;
        this.Inicio = undefined
        this.Inclusao = undefined;
        this.Alteracao = undefined;
        this.Exclusao = undefined;
        this.Manutencao = undefined;
        this.NomeTabela = undefined;
    }
}
